/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRMCHLink
 */
export interface CRMCHLink {
    /**
     * 
     * @type {string}
     * @memberof CRMCHLink
     */
    value?: string;
}

/**
 * Check if a given object implements the CRMCHLink interface.
 */
export function instanceOfCRMCHLink(value: object): value is CRMCHLink {
    return true;
}

export function CRMCHLinkFromJSON(json: any): CRMCHLink {
    return CRMCHLinkFromJSONTyped(json, false);
}

export function CRMCHLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRMCHLink {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function CRMCHLinkToJSON(json: any): CRMCHLink {
    return CRMCHLinkToJSONTyped(json, false);
}

export function CRMCHLinkToJSONTyped(value?: CRMCHLink | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

